import "./Hobbies.scss";
const Hobbies = () => {
  return (
    <section className="hobbies" id="hobbies">
      <div className="hobbies__inner">
        <h2 className="hobbies__heading">Off the ball</h2>
        <p className="hobbies__body">
          Two decades of playing the game, currently at Kreisklasse level in
          Mannheim; it's the reason I trust my read of a match as much as I
          trust a model's. Coaching SpVgg Wallstadt 3 keeps that honest: a
          tactical idea only counts once it survives a training session with
          real players in real weather. Apart from football, I love to hike
          and play board games.
        </p>
      </div>
    </section>
  );
};

export default Hobbies;
